module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0008_08_B18_3.f218876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0008_08_B18_3.jpg
// module id = nkd3
// module chunks = 0